import { ReactNode } from 'react'

type CardProps = {
  tone?: string
  className?: string
  children: ReactNode
}

export const Card = ({ tone = '', className = '', children }: CardProps) => {
  return (
    <div className={`ph-grid d-flex ${className}`}>
      <div className={`ph-card card-ct flex-fill ${tone}`}>{children}</div>
    </div>
  )
}
